<template>
  <ion-app>

    <side-menu/>
    
    <ion-router-outlet id="ion-router-outlet-id" />
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { defineComponent } from 'vue';
import SideMenu from './views/SideMenu.vue';

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
    SideMenu
  }
});
</script>